export var AddTagType = {
  UserInput: 'user-input',
  Suggestion: 'suggestion'
};